<template>
  <div
    class="pt-5"
  >
    <header class="my-3 sm:my-4 md:my-5 lg:my-6">
      <h2 class="mb-2 lg:mb-5 text-center">
        {{ title }}
      </h2>
    </header>
    <div
      class="p-3 sm:p-4 shadow bg-white mt-5 rounded-10"
    >
      <h3>
        {{ t('ready_mixes_title') }}
      </h3>
      <Items
        :items="getProductCategories"
      />
    </div>
    <div
      class="p-3 sm:p-4 shadow bg-white mt-5 rounded-10"
    >
      <h3>
        {{ t('mixes_title') }}
      </h3>
      <Items
        :items="getMixCategories"
      />
    </div>
  </div>
</template>

<script setup>
import Items from "@/components/menus/megamenu/TheMegamenuChildItems.vue";
import { storeToRefs } from "pinia";
import { useCategoriesStore } from '@/stores/CategoriesStore'
import { useI18n } from "vue-i18n";

const { t } = useI18n()

defineProps({
  title: {
    type: String,
    default: 'Nevybrali jste si? Máme toho více!',
  },
})

const categoriesStore = useCategoriesStore()
const { getProductCategories, getMixCategories } = storeToRefs(categoriesStore)
</script>

<i18n>
  {
    "cs": {
    "mixes_title": "Namixujte si vlastní dobrotu",
    "ready_mixes_title": "Kategorie"
},
    "sk": {
    "mixes_title": "Mixovať",
    "ready_mixes_title": "Produkty"
},
    "pl": {
    "mixes_title": "Mieszaj",
    "ready_mixes_title": "Produkty"
},
    "hu": {
    "mixes_title": "Mixelni",
    "ready_mixes_title": "Termékek"
},
    "de": {
    "mixes_title": "Mixen",
    "ready_mixes_title": "Produkte"
},
    "at": {
    "mixes_title": "Mixen",
    "ready_mixes_title": "Produkte"
},
    "ro": {
    "mixes_title": "Amestecă",
    "ready_mixes_title": "Produse"
},
    "fr": {
    "mixes_title": "Créez votre propre gourmandise",
    "ready_mixes_title": "Catégories"
},
    "it": {
    "mixes_title": "Mescola la tua prelibatezza",
    "ready_mixes_title": "Categoria"
}
  }
</i18n>
